import * as React from "react"
const ActiveDotIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={6}
        height={6}
        fill="none"
        {...props}
    >
        <path fill={props.fill ? props.fill : "#22C55E"} d="M5 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
    </svg>
)
export default ActiveDotIcon
